import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    container:  {
        marginTop: -10,
    },
    rightToolbar: {
        marginLeft: 'auto',
        marginRight: -12,
    },
    button: {
        textTransform: 'none'
    }
}));